<template>
    <div class="card" style="min-height: calc(100vh - 180px)">
        <div class="bg-blue-light p-1">
            <TitleButton
                btnTitle="List"
                :showBtn="true"
                :showAddNew="false"
                title="Update Purchase Bill"
                @onClickCloseButton="navigateToListPage"
            />

            <div class="row mt-2 gy-1">
                <div class="col-md-4">
                    <input
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        tabindex="1"
                        type="date"
                        placeholder=""
                        v-model="formData.date"
                    >
                </div>
                <div class="col-md-4">
                    <v-select
                        placeholder="Select Business"
                        v-model="formData.business_id"
                        :options="business"
                        label="name"
                        :reduce="name => name.id"
                    />
                </div>
                <div class="col-md-4 d-flex align-items-center justify-content-between">
                    <AsyncSelect
                        placeholder="Select Contact"
                        v-model="contactProfile"
                        :api-service="fetchContactProfiles"
                        :format-label="formatPatientLabel"
                        class="flex-grow-1"
                        :additional-query="{type: 'supplier'}"
                    />
                    <span class="filter-search-icon cursor-pointer mx-1" @click="onOpenContactSearchModal">
                      <i class="fas fa-search"></i>
                    </span>
                </div>
                <div class="col-md-4">
                    <v-select
                        placeholder="Account Head"
                        v-model="formData.account_head_id"
                        :options="accountPayable"
                        label="name"
                        :reduce="name => name.id"
                    />
                </div>

                <div class="col-md-4">
                    <v-select
                        placeholder="Select Warehouse Location"
                        v-model="formData.location_id"
                        :options="locations"
                        label="text"
                        :reduce="text => text.id"
                    />
                </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center justify-content-md-end mb-1">
                  <div class="input-group input-group-merge invoice-edit-input-group">
                    <div class="input-group-text">
                      <span>{{ prefix }}-</span>
                    </div>
                    <input type="number" min="1" class="form-control invoice-edit-input" placeholder="" v-model="serial">
                  </div>
                </div>
              </div>
                <div class="col-md-4">
                    <label class="form-label mb-0" for="bill-referance-no">Bill Ref No</label>
                    <input
                        id="bill-referance-no"
                        class="form-control invoice-edit-input"
                        type="text"
                        placeholder="Bill Ref No"
                        v-model="formData.bill_referance_no"
                    >
                </div>
                <div class="col-md-4">
                    <label class="form-label mb-0" for="bill-referance-date">Bill Ref Date</label>
                    <input
                        id="bill-referance-date"
                        class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                        type="date"
                        placeholder="Bill Ref Date"
                        v-model="formData.bill_referance_date"
                    >
                </div>
                <div v-if="isItem" class="col-md-4">
                    <label class="form-label mb-0" for="purchase-barcode-scan">Barcode / SKU</label>
                    <BarcodeScanInput
                        input-id="purchase-barcode-scan"
                        :api-service="fetchProductList"
                        :additional-query="{ dropdown: 1, with_rate: 1 }"
                        @scanned="onBarcodeScanned"
                    />
                </div>
            </div>
        </div>

        <div class="px-2">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <a @click="formData.has_item_detail = true" :class="{'active' : formData.has_item_detail}" class="nav-link" data-bs-toggle="tab"  aria-controls="home" role="tab" aria-selected="true">Item Details</a>
                </li>
                <li class="nav-item">
                    <a @click="formData.has_item_detail = false" :class="{'active' : !formData.has_item_detail}" class="nav-link" data-bs-toggle="tab" aria-controls="profile" role="tab" aria-selected="false">Accounts Details</a>
                </li>
            </ul>
        </div>

        <div class="px-3">
            <Bill
                class="mt-2"
                v-for="(data, index) in itemsDetails"
                :key="data.row_key || index"
                :index="index"
                :data="data"
                :accountHeads="accountHeads"
                :vatRate="vatRate"
                :isItem="isItem"
                :business="business"
                :costCentList="costCentList"
                @onClose="removeBill"
                @onClickToApplyTdsVds="() => onClickToApplyTdsVds(data)"
            />
            <Bill
                class="mt-2"
                v-for="(data, index) in accountsDetails"
                :key="index"
                :index="index"
                :data="data"
                :accountHeads="accountHeads"
                :vatRate="vatRate"
                :isItem="isItem"
                :business="business"
                :costCentList="costCentList"
                @onClose="removeBill"
                @onClickToApplyTdsVds="() => onClickToApplyTdsVds(data)"
            />
        </div>

        <div class="px-2 mt-2">
            <button @click="addNewBill" class="btn btn-primary">Add line</button>
        </div>
        
        <div class="px-2">
          <div class="row justify-content-end">
            <div class="col-12 col-md-4">
              <div class="row">
                <div class="col-12">
                  <div class="mb-1 row">
                    <div class="col-sm-4">
                      <label class="col-form-label" for="first-name">Sub total</label>
                    </div>
                    <div class="col-sm-8">
                      <input
                        v-model="subTotal"
                        readonly
                        type="text"
                        class="form-control text-right"
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-1 row">
                    <div class="col-sm-4">
                      <label class="col-form-label" for="first-name">VAT</label>
                    </div>
                    <div class="col-sm-8">
                      <input
                        v-model="totalVAT"
                        readonly
                        type="text"
                        class="form-control text-right"
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-1 row">
                    <div class="col-sm-4">
                      <label class="col-form-label" for="first-name">Total Amount</label>
                    </div>
                    <div class="col-sm-8">
                      <input
                        v-model="total"
                        readonly
                        type="text"
                        class="form-control text-right"
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-1 row">
                    <div class="col-sm-4">
                      <label class="col-form-label" for="discount-amount">Adjustment Amount</label>
                    </div>
                    <div class="col-sm-8">
                      <input
                        id="discount-amount"
                        v-model.trim="discountAmount"
                        type="number" class="form-control form-control-sm discount-adj ml-auto text-right"
                        placeholder="amount"
                        :min="0"
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12" v-if="discountAmount > 0">
                  <div class="mb-1 row">
                    <div class="col-sm-4">
                      <label class="col-form-label" for="discount-amount">Settlement Account</label>
                    </div>
                    <div class="col-sm-8">
                      <v-select
                        placeholder="Select Discount Head"
                        v-model="formData.discount_head_id"
                        :options="salesAccountHeads"
                        label="name"
                        :reduce="name => name.id"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-1 row">
                    <div class="col-sm-4">
                      <label class="col-form-label" for="advance-amount">Advance Adjustment Amount</label>
                    </div>
                    <div class="col-sm-8">
                      <input
                        id="advance-amount"
                        v-model="formData.advance_amount"
                        readonly
                        type="text"
                        class="form-control text-right"
                        @click="openAdvanceModal"
                      >
                      <small v-if="totalAvailableAdvance > 0" class="text-danger">Available Advance: {{ totalAvailableAdvance.toLocaleString() }}</small>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-1 row">
                    <div class="col-sm-4">
                      <label class="col-form-label" for="discount-amount">Net Bill</label>
                    </div>
                    <div class="col-sm-8 text-right px-2">
                      {{grandTotal ?? 0}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 px-2">
            <div class="mb-1">
                <label class="form-label" for="description">Memo</label>
                <vField
                    as="textarea"
                    name="description"
                    v-model="formData.description"
                    class="form-control"
                />
            </div>
        </div>

        <div class="pb-5 px-2 mt-4">
            <div class="d-flex flex-wrap gap-1 gy-2">
                <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(true)" class="btn btn-primary">Update</button>
                <button :disabled="productLoader" @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
            </div>
        </div>
        <GlobalLoader />
        <ContactDropdownFilter
            v-if="store.state.isModalOpenThree"
            @onSearchContact="onSearchContact"
            type="supplier"
            :companyRoles="companyRoles"
        />

        <ApplyTdsVdsModal
            :data="itemDetails"
            :tdsRateList="tdsRateList"
            :vdsRateList="vdsRateList"
            @onSaveTdsVds="onSaveTdsVds"
            v-if="store.state.isModalOpen && isItem"
            :tdsPayableHeads="tdsPayableHeads"
            :vdsPayableHeads="vdsPayableHeads"
        />

        <ApplyTdsVdsHeadModal
            v-if="store.state.isModalOpen && !isItem"
            :data="accountDetails"
            :tdsRateList="tdsRateList"
            :vdsRateList="vdsRateList"
            @onSaveTdsVds="onSaveTdsVds"
            :tdsPayableHeads="tdsPayableHeads"
            :vdsPayableHeads="vdsPayableHeads"
            :accountHeads="accountHeads"
        />

        <PurchaseAdvanceSelectionModal
            v-if="store.state.isAdvanceModalOpen"
            :receipts="advanceReceiptList"
            :total="advanceCap"
        />
    </div>
</template>

<script setup>
import { ref, inject, reactive, onMounted, computed, watch, provide, nextTick } from 'vue'
import {vatRate} from '@/data/inventory.js'
import { useRouter, useRoute } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import handleContact from '@/services/modules/contact'
import TitleButton from '@/components/atom/TitleButton' 
import Bill from '@/components/molecule/company/inventory/purchase/Bill.vue'

import {editVoucherNumber} from "@/services/utils/voucherNumberGenerator";
import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useStore} from "vuex";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import ApplyTdsVdsModal from "@/components/molecule/company/inventory/purchase/ApplyTdsVdsModal.vue";
import handleTdsVds from '@/services/modules/procurement/tdsVds'
import ApplyTdsVdsHeadModal from "@/components/molecule/company/inventory/purchase/ApplyTdsVdsHeadModal.vue";
import handleDropdowns from '@/services/modules/dropdowns';
import PurchaseAdvanceSelectionModal
  from "@/components/molecule/company/inventory/purchase/PurchaseAdvanceSelectionModal.vue";
import BarcodeScanInput from "@/components/molecule/input-field/BarcodeScanInput.vue";

const router = useRouter()
const route = useRoute()
const store = useStore()

const showError =  inject('showError');
const showSuccess =  inject('showSuccess');

const {fetchProductList, fetchAccountHead, fetchPurchaseBill, fetchContactPurchaseAdvances, ...rest} = handlePurchase()
const {fetchContactProfiles} = handleContact()
const { formatPatientLabel } = useAsyncDropdownHelper();
const { fetchDropdownList } = handleDropdowns();

const companyId = computed(() => {
    return route.params.companyId
})
const itemDetails = ref(null);
let loader =ref(false)
let productLoader =ref(false)
let saveButtonLoader=ref(false)
let saveNewButtonLoader =ref(false)
let accountHeads = ref([])
let business = ref([])
let locations = ref([])
const tdsRateList = ref([]);
const vdsRateList = ref([]);
let salesAccountHeads = ref([])
let accountPayable = ref([])
let prefix = ref('')
let serial = ref('')
const discountAmount = ref('');
let fetchedFromAPI = ref(false)
const contactProfile = ref(null);
const companyRoles = ref([]);
const accountDetails = ref([]);
const costCentList = ref([]);
const advanceReceiptList = ref([]);
const isBillLoaded = ref(false);
const otherSettledAmount = ref(0);
const hasOtherTdsVdsSettlement = ref(false);
let lastScanRowKey = 0;
let formData = ref({
    company_id: companyId,
    contact_profile_id: null,
    account_head_id: null,
    business_id: null,
    location_id: null,
    bill_number: '',
    bill_referance_no: '',
    bill_referance_date: '',
    status: 'active',
    date: '',
    has_item_detail: true,
    description: '',
    advance_amount: 0,
    advance_receipts: [],
    account_details: [],
    item_details: [{
            product_id: null,
            quantity: '',
            rate: '',
            vat: '',
            vat_amount: 0,
            description: ""
        }],
})

provide('formData', formData);

const vdsPayableHeads = ref([]);
const tdsPayableHeads = ref([]);

onMounted(async () => {
    loader.value=true

    formData.value.date =  new Date().toISOString().split('T')[0]
    const companyQuery = `?company_id=${companyId.value}`
    const fetchSingePurchaseBill = fetchPurchaseBill(route.params.purchaseId, companyQuery)
    const dropdownRes = fetchDropdownList(getDropDownQuery());

    Promise.all([
        dropdownRes.then(res => {
            if(! res.status) return;
            accountHeads.value = res.data.account_heads;
            business.value = res.data.business_list;
            locations.value = res.data.business_location_list;
            companyRoles.value = res.data.company_role_list;
            tdsRateList.value = res.data.tds_rate;
            vdsRateList.value = res.data.vds_rate;
            costCentList.value = res.data.cost_centre_list;

            if(res.data.account_head_list_by_slag.accounts_payable) {
                accountPayable.value = res.data.account_head_list_by_slag.accounts_payable;
                formData.value.account_head_id = res.data.account_head_list_by_slag.accounts_payable[0].id;
            }

            if(res.data.account_head_list_by_slag.sales_accounts) {
                salesAccountHeads.value = res.data.account_head_list_by_slag.sales_accounts;
            }

            if(res.data.account_head_list_by_slag.tds_payable) {
                tdsPayableHeads.value = res.data.account_head_list_by_slag.tds_payable;
            }

            if(res.data.account_head_list_by_slag.vds_payable) {
                vdsPayableHeads.value = res.data.account_head_list_by_slag.vds_payable;
            }
        }),
        fetchSingePurchaseBill.then(resp => {
            if(resp.data) {
                let voucher = editVoucherNumber(resp.data.bill_number);
                prefix.value = voucher.prefix;
                serial.value = voucher.serial;
                fetchedFromAPI.value = true
                formData.value = resp.data
                discountAmount.value = toAdjustmentInput(parseFloat((parseFloat(resp.data.adjustment_amount || 0) - sumPaymentAdjustments(resp.data.payment_general)).toFixed(4)))
                formData.value.adjustment_amount = discountAmount.value
                loadOtherSettlement(resp.data.payment_general)
                formData.value.advance_amount = resp.data.advance_adj_amount ? parseFloat(resp.data.advance_adj_amount) : 0
                formData.value.advance_receipts = mapBillAdvanceReceipts(resp.data.payment_general)
                advanceReceiptList.value = prefillAdvanceReceipts(resp.data.advance_payments)
                contactProfile.value = resp.data.contact
                if(resp.data.has_item_detail) {
                    formData.value.item_details = resp.data.general
                    formData.value.has_item_detail = true
                } else {
                    formData.value.account_details = resp.data.ledgers
                    formData.value.has_item_detail = false
                }
            }
            nextTick(() => { isBillLoaded.value = true })
        }),
    ])
        .then(() => {loader.value=false})
        .catch((err)=>{loader.value=false})
//   getProduct()
})

const getDropDownQuery = () => {
    let query = `?company_id=${companyId.value}
                &is_business=1
                &is_business_location=1
                &is_cost_centre=1
                &is_account_heads=1
                &is_role=1
                &is_tds_rate=1
                &is_vds_rate=1
                &is_all_account_heads=1
                &slags[]=sales_accounts
                &slags[]=tds_payable
                &slags[]=vds_payable
                &slags[]=accounts_payable`;
                
    return query;
}

const hasItemDetails = computed(() => {
    return formData.value.has_item_detail;
})
const accountsDetails = computed(() => {
    return formData.value.account_details
})
const itemsDetails = computed(() => {
    return formData.value.item_details
})

const isItem = computed(() => {
    return formData.value.has_item_detail ? true : false
})
const selectionText = computed(() => {
    return formData.value.has_item_detail ? 'Item details' : 'Accounting Details'
})

const subTotal = computed(() => {
    let subTotal=0
    if(formData.value.has_item_detail) {
        formData.value.item_details.map(item => {
            subTotal += parseFloat(((item.quantity * item.rate) - (item.discount_amount ?? 0)).toFixed(4))
        })
    }
    if(!formData.value.has_item_detail && formData.value.account_details) {
        formData.value.account_details.map(item => {
            if(item.amount) {subTotal += parseFloat((parseFloat(item.amount) - (item.discount_amount ?? 0)).toFixed(4))}
        })
    }

    return parseFloat(subTotal.toFixed(4))
})

const totalVAT = computed(() => {
    let vat=0
    if(formData.value.has_item_detail) {
        formData.value.item_details.map(item => {
          if(item.vat_amount) {
            vat += parseFloat(parseFloat(item.vat_amount).toFixed(4))
          }
        })
    }
    if(!formData.value.has_item_detail && formData.value.account_details) {
        formData.value.account_details.map(item => {
          if(item.vat_amount) {
            vat += parseFloat(parseFloat(item.vat_amount).toFixed(4))
          }
        })
    }

    return parseFloat(vat.toFixed(4))
})

const total = computed(() => {
    return parseFloat((parseFloat(subTotal.value) + parseFloat(totalVAT.value)).toFixed(4))
})

const grandTotal = computed(() => parseFloat((total.value - discountAmount.value - parseFloat(formData.value.advance_amount)).toFixed(4)))

const afterDiscountTotal = computed(() => parseFloat((total.value - discountAmount.value).toFixed(4)))

const currentDetails = computed(() => {
    if (formData.value.has_item_detail) return formData.value.item_details
    return formData.value.account_details
})

const billTdsVds = computed(() => {
    if (! currentDetails.value) return 0
    return currentDetails.value.reduce((sum, item) => sum + parseFloat(item.tds_amount || 0) + parseFloat(item.vds_amount || 0), 0)
})

const unsettledTdsVds = computed(() => {
    if (hasOtherTdsVdsSettlement.value) return 0
    return billTdsVds.value
})

const advanceCap = computed(() => parseFloat((afterDiscountTotal.value - otherSettledAmount.value - unsettledTdsVds.value).toFixed(4)))

const selectedSupplierId = computed(() => formData.value.contact_profile_id)

const totalAvailableAdvance = computed(() => parseFloat(advanceReceiptList.value.reduce((sum, receipt) => sum + parseFloat(receipt.available_amount), 0).toFixed(4)))

const hasUnadjustedAdvance = computed(() => totalAvailableAdvance.value > 0 && ! (parseFloat(formData.value.advance_amount) > 0))

watch(hasItemDetails, (newValue, oldValue) => {
    if(!newValue) {
        if(!fetchedFromAPI.value){
            delete formData.value.item_details
            formData.value.account_details = [{
                account_head_id: null,
                amount: '',
                vat: 15,
                vat_amount: 0,
                description: '',
                taxable_amount: null,
                tax_rate: null
            }]
        } else {
            fetchedFromAPI.value = false
        }
    }
    if(newValue) {
        if(!fetchedFromAPI.value){
            delete formData.value.account_details
            formData.value.item_details = [{
                product_id: null,
                quantity: '',
                rate: '',
                vat: 15,
                vat_amount: 0,
                description: ""
            }]
        } else {
            fetchedFromAPI.value = false
        }
    }
})

watch(discountAmount, (newValue, oldValue) => {
  formData.value.adjustment_amount = discountAmount.value

  if (isBillLoaded.value && advanceReceiptList.value.length && newValue !== oldValue) {
    formData.value.advance_amount = 0
    formData.value.advance_receipts = []
  }
})

watch(selectedSupplierId, (newValue) => {
  if (! isBillLoaded.value) return

  const advanceQuery = `?company_id=${companyId.value}&purchase_master_id=${route.params.purchaseId}`
  advanceReceiptList.value = []
  formData.value.advance_amount = 0
  formData.value.advance_receipts = []

  if (! newValue) return

  fetchContactPurchaseAdvances(newValue, advanceQuery).then(res => {
    if (newValue !== selectedSupplierId.value) return
    if (! res.status) return
    advanceReceiptList.value = res.data
  }).catch(() => {})
})

const openAdvanceModal = () => {
  if (! selectedSupplierId.value) {
    showError("Please select supplier first")
    return
  }

  if (! advanceReceiptList.value.length) {
    showError("No advance receipts found")
    return
  }

  store.state.isAdvanceModalOpen = true
}

function mapBillAdvanceReceipts(paymentGenerals) {
  if (! paymentGenerals) return []
  return paymentGenerals
    .filter(general => general.payment_type === 'advance_payment')
    .map(general => ({ advance_receipt_id: general.payment_master_id, advance_amount: parseFloat(general.paid_amount) }))
}

function toAdjustmentInput(amount) {
  if (! (amount > 0)) return ''
  return amount
}

function paymentAdjustment(general) {
  return parseFloat(general.vds_payable_amount || 0) + parseFloat(general.tds_payable_amount || 0) + parseFloat(general.discount_receipt_amount || 0)
}

function sumPaymentAdjustments(paymentGenerals) {
  if (! paymentGenerals) return 0
  return paymentGenerals.reduce((sum, general) => sum + paymentAdjustment(general), 0)
}

function loadOtherSettlement(paymentGenerals) {
  if (! paymentGenerals) return
  const otherPayments = paymentGenerals.filter(general => general.payment_type !== 'advance_payment')
  otherSettledAmount.value = otherPayments.reduce((sum, general) => sum + parseFloat(general.paid_amount || 0) + paymentAdjustment(general), 0)
  hasOtherTdsVdsSettlement.value = otherPayments.some(general => parseFloat(general.tds_payable_amount || 0) + parseFloat(general.vds_payable_amount || 0) > 0)
}

function prefillAdvanceReceipts(receipts) {
  if (! receipts) return []
  const adjustedById = {}
  formData.value.advance_receipts.forEach(receipt => {
    adjustedById[receipt.advance_receipt_id] = receipt.advance_amount
  })
  return receipts.map(receipt => ({ ...receipt, advance_amount: adjustedById[receipt.id] || null }))
}

watch(contactProfile, (newVal) => {
    if(!newVal) {
        formData.value.contact_profile_id = null;
        return ;
    }

    formData.value.contact_profile_id = newVal.id;
})

const onClickToApplyTdsVds = (item) => {
    if(isItem.value) {
        itemDetails.value = item;
    } else {
        accountDetails.value = item;
    }
    store.state.isModalOpen = true;
}

const onSaveTdsVds = (data) => {
    if(isItem.value) {
        for(let key in data) {
            itemDetails.value[key] = data[key];
        }
        return;
    }
    for(let key in data) {
        accountDetails.value[key] = data[key];
    }
}

function navigateToListPage() {
    router.push({name: 'purchase-list', params: route.params, query: route.query})
}

function removeBill(index) {
    if(hasItemDetails.value) {
        formData.value.item_details.splice(index, 1)
    }
    if(!hasItemDetails.value) {
        formData.value.account_details.splice(index, 1)
    }
}

function addNewBill() {
    if(hasItemDetails.value) {
        formData.value.item_details.push({
            product_id: null,
            quantity: '',
            rate: '',
            vat: 15,
            vat_amount: 0,
            description: ''
        })
    }
    if(!hasItemDetails.value) {
        formData.value.account_details.push({
            account_head_id: null,
            amount: '',
            vat: 15,
            vat_amount: 0,
            description: '',
            taxable_amount: null,
            tax_rate: null
        })
    }
}
function onBarcodeScanned(row) {
    const existingLine = formData.value.item_details.find(item => item.product_id === row.id)
    if (existingLine) {
        showError(`${row.text} is already added`)
        return
    }

    addScannedLine(row)
}

function addScannedLine(row) {
    const lines = formData.value.item_details
    while (lines.length && ! lines[lines.length - 1].product_id) {
        lines.pop()
    }

    lastScanRowKey += 1
    lines.push({
        row_key: `scan-${lastScanRowKey}`,
        product_id: row.id,
        quantity: '',
        rate: '',
        vat: 15,
        vat_amount: 0,
        description: '',
        account_head_name: row.inventory_account_head_name,
        vds_id: row.vds_id,
        vds_rate: row.vds_rate,
        tds_id: row.tds_id,
        tds_rate: row.tds_rate,
        product: {
            ...row,
            name: row.text
        }
    })
}

function handleSubmit(redirect=false) {
    if (hasUnadjustedAdvance.value && ! confirm('This party has available advance amount, but no advance has been adjusted in this purchase bill. Do you want to continue?')) return
    saveButtonLoader.value = true
    let purchaseId = route.params.purchaseId;
    formData.value.bill_number = prefix.value+'-'+serial.value
    if(!formData.value.date) formData.value.date = new Date().toISOString().split('T')[0]
    let copyFormData = JSON.parse(JSON.stringify(formData.value))
    copyFormData.has_item_detail = formData.value.has_item_detail ? 1 : 0
    if(isItem.value) {
        delete copyFormData.account_details
        copyFormData.item_details = formData.value.item_details
    }else {
        delete copyFormData.item_details
        copyFormData.account_details = formData.value.account_details
    }
    rest.updateBill(purchaseId, copyFormData)
        .then(res => {
            saveButtonLoader.value = false
            saveNewButtonLoader.value = false
            if(res.status) {
                showSuccess(res.message)
                navigateToListPage()
            }
            if(!res.status) {
                showError(res.message)
            }
        })
        .catch(err=> {
            saveButtonLoader.value = false;
            saveNewButtonLoader.value = false;
            productLoader.value = false;
            (err)
        })
}

// have to refactor
function resetForm() {
    if(!isItem.value) {
        formData.value.account_details = [{
            account_head_id: null,
            amount: '',
            vat: '',
            vat_amount: 0,
            description: '',
            taxable_amount: null,
            tax_rate: null
        }]
    }
    if(isItem.value) {
        formData.value.item_details = [{
            product_id: null,
            quantity: '',
            rate: '',
            vat: '',
            vat_amount: 0,
            description: ""
        }]
    }
}

function onOpenContactSearchModal () {
    store.state.isModalOpenThree = true;
}

function onSearchContact (contact) {
    contactProfile.value = contact
}

</script>